import { render, staticRenderFns } from "./LegContainerSealNoDialog.vue?vue&type=template&id=77e0c2c4"
import script from "./LegContainerSealNoDialog.vue?vue&type=script&lang=js"
export * from "./LegContainerSealNoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports